module.exports = Object.freeze({
  // Environment- based configuration(loaded from.env file)

  FRONTEND_BASE_URL: process.env.REACT_APP_FRONTEND_BASE_URL,
  BASE_URL: process.env.REACT_APP_BASE_URL,
  BASE_NODE_URL: process.env.REACT_APP_BASE_NODE_URL,
  ZOHO_REDIRECT_URL_FRONTEND: process.env.REACT_APP_ZOHO_REDIRECT_URL_FRONTEND,
  BUCKET_BASE_URL: process.env.REACT_APP_BUCKET_BASE_URL,
  PRODUCT_IMAGES_BASE_URL: process.env.REACT_APP_PRODUCT_IMAGES_BASE_URL,
  ELASTIC_SEARCH_BASE_URL: process.env.REACT_APP_ELASTIC_SEARCH_BASE_URL,
  VIEW_STORE_URL: process.env.REACT_APP_VIEW_STORE_URL,
  IS_ELASTIC_SEARCH_ON: true,//process.env.REACT_APP_IS_ELASTIC_SEARCH_ON,
  IS_DISCOUNT_GRAPH_ON: false, //process.env.REACT_APP_IS_DISCOUNT_GRAPH_ON,
  IS_PY_GRAPHS: true,
  REPORTS_BASE_URL: process.env.REACT_APP_REPORTS_BASE_URL,
  GEOCODE_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  AI_IFRAME_ORIGIN: process.env.REACT_APP_AI_IFRAME_ORIGIN,
  BASE_URL_CHATBOT: process.env.REACT_APP_BASE_URL_CHATBOT,
  // QA SERVER
  // IS_PY_GRAPHS: true,
  // REPORTS_BASE_URL: "https://reports-api-qa.quickvee.us/",
  // BASE_URL: "https://api-ci.quickvee-qa.com/",
  // BASE_NODE_URL: "https://qa-api-node.quickvee.us/",
  // FRONTEND_BASE_URL: "https://quickvee-qa.com/",
  // ZOHO_REDIRECT_URL_FRONTEND:
  //   "https://quickvee-qa.com/merchants/store-reporting/zoho-connect",
  // BUCKET_BASE_URL: "https://quickvee-products.s3.us-east-1.amazonaws.com/",
  // PRODUCT_IMAGES_BASE_URL: "https://quickvee-products.s3.us-east-1.amazonaws.com/",
  // ELASTIC_SEARCH_BASE_URL: "https://qa-elasticsearch.quickvee.us/",
  // VIEW_STORE_URL: "https://qa.quickvee-qa.com/",
  // IS_ELASTIC_SEARCH_ON: true,
  // AI_IFRAME_ORIGIN: "https://ai.quickvee.com",
  // BASE_URL_CHATBOT: "https://merchant-assistant.quickvee-qa.com/python",

  // Live Server URL
  // BASE_URL: "https://api-ci.quickvee.us/", // Live
  // BASE_NODE_URL: "https://api-node.quickvee.us/", // Live
  // FRONTEND_BASE_URL: "https://quickvee.com/", // Live
  // ZOHO_REDIRECT_URL_FRONTEND:
  //   "https://quickvee.com/merchants/store-reporting/zoho-connect", // Live
  // BUCKET_BASE_URL: "https://quickvee-live.s3.us-east-1.amazonaws.com/", // live bucket
  // PRODUCT_IMAGES_BASE_URL: "https://quickvee-live.s3.us-east-1.amazonaws.com/", // live bucket
  // ELASTIC_SEARCH_BASE_URL: "https://elasticsearch.quickvee.us/", // LIVE
  // VIEW_STORE_URL: "https://quickvee.com/", // Live
  // REPORTS_BASE_URL: "https://reports-api.quickvee.us/", // Live
  // IS_ELASTIC_SEARCH_ON: true,
  // IS_DISCOUNT_GRAPH_ON: false,

  // Quickvee.us SERVER Live Copy
  // BASE_URL: "https://php-dev.quickvee.us/", // Live
  // BASE_NODE_URL: "https://dev-api-node.quickvee.us/", // Live
  // FRONTEND_BASE_URL: "https://quickvee.us/", // Live
  // ZOHO_REDIRECT_URL_FRONTEND:
  //   "https://quickvee.us/merchants/store-reporting/zoho-connect", // Live
  // BUCKET_BASE_URL: "https://quickvee-live.s3.us-east-1.amazonaws.com/", // live bucket
  // PRODUCT_IMAGES_BASE_URL: "https://quickvee-live.s3.us-east-1.amazonaws.com/", // live bucket
  // ELASTIC_SEARCH_BASE_URL: "https://elasticsearch.quickvee.us/", // LIVE
  // VIEW_STORE_URL: "https://quickvee.us/", // Live
  // REPORTS_BASE_URL: "https://reports-api.quickvee.us/", // Live
  // IS_ELASTIC_SEARCH_ON: true,
  // IS_DISCOUNT_GRAPH_ON: false,

  // Product list v2 (`new_purchase_orders_product_list_v2`): use elastic when
  // connected; Node is the fallback. Independent of deal-picker routing below.
  // for Stocktake & Purchase Order Product List V2
  USE_ELASTIC_FOR_PO_PRODUCT_LIST_V2: true,

  // BOGO / Mix & Match / Item Coupon product modals: force Node API for now
  // (do not hit elastic even when IS_ELASTIC_SEARCH_ON is true).
  FORCE_NODE_API_FOR_DEAL_PRODUCT_PICKERS: true,

  // Stocktake App (/stocktake-app, /stocktake-app/:id) and Purchase Order
  // (/purchase-order, /purchase-order/add, /purchase-order/:id): force Node API
  // for every product lookup — product list, UPC scan and stocktake search.
  // Do not hit elastic even when IS_ELASTIC_SEARCH_ON and
  // elastic-when-connected routing.
  FORCE_NODE_API_FOR_STOCKTAKE_AND_PURCHASE_ORDER: true,

  // SECRET_KEY: process.env.REACT_APP_SECRET_KEY,
  SECRET_KEY: "secret key",
  /** localStorage key: `id` from LoginApiReact/create_session; not overwritten on store switch */
  QV_SESSION_LOGIN_ID_STORAGE_KEY: "qv_session_login_id",
  /** @deprecated read fallback only — migrate to QV_SESSION_LOGIN_ID_STORAGE_KEY */
  QV_LOGIN_ID_STORAGE_KEY_LEGACY: "qv_login_id",
  //ZOHO
  ZOHO_REDIRECT_URL: "zohoauth_pk/oauth2callback",
  GET_ZOHO_AUTH_DATA: "Zoho_pk/get_zoho_auth_data",
  GET_ZOHO_invoice_DATA: "Zoho_pk/fetch_zoho_invoices",
  GET_ZOHO_CUSTOM_FIELD: "Zoho_pk/getZohoCustomFieldSetting",
  SAVE_PRODUCT_MAPPING: "Zoho_pk/saveFieldMappings",
  // Categories API calls

  ADD_CATOGRY: "CategoryReactapi/addnewcolln",
  ADD_CATEGORY: "Categoryapi/add_category",
  CATEGORY_LIST: "Categoryapi/category_list",
  UPDATE_CATOGRY: "CategoryReactapi/updateCategory",
  // LIST_ALL_CATEGORIES: "CategoryReactapi/category_list",
  DELETE_SINGLE_CATEGORIE: "CategoryReactapi/delete_category",
  BULK_DELETE_CATEGORY: "CategoryReactapi/bulk_delete_category",
  MASS_UPDATE_CATEGORY_TAX: "CategoryReactapi/mass_update_category_tax",
  PRODUCT_LIST_BY_CATEGORY: "CategoryReactapi/product_list_by_category",
  CATEGORIE_STATUS: "CategoryReactapi/categoryapi_status",
  CATEGORIE_BANNER_REMOVE: "CategoryReactapi/delete_banner_image",
  EDIT_CATOGRY_DATA: "CategoryReactapi/category_data",
  SORT_CATOGRY_DATA: "CategoryReactapi/SaveSizeSorting",
  ITEMS_SALES_REPORT_API: "api/reports/items_sales_report_api",

  // DASHBOARD CHARTS
  REVENUE_CHART: "ReportingReactapi/revenue_data_api",
  SALES_COUNT_CHART: "NewDashboardReact/sales_count_api",
  CUSTOMER_COUNT_CHART: "ReportingReactapi/customer_count_api",
  DISCOUNT_CHART: "ReportingReactapi/discount_api",
  DISCOUNT_CHART_HOURLY: 'Sale_summary_api/discount_api_hourly',//"ReportingReactapi/discount_api_hourly",
  GROSS_PROFIT_CHART: "NewDashboardReact/gross_profit_api",
  PERCENTAGE_DISCOUNT_CHART: "NewDashboardReact/discount_in_per_api",
  PERCENTAGE_DISCOUNT_CHART_HOURLY: 'Sale_summary_api/discount_given_percentage_hourly',
  DISCOUNT_CHART_NEW: "ReportingReactapi/discount_api_new",
  UPDATE_DISCOUNT_RUN_TIME_DATA: "ReportingReactapi/discount_updated_data",
  PERCENTAGE_DISCOUNT_CHART_NEW: "NewDashboardReact/discount_in_per_api_new",
  UPDATE_DISCOUNT_PERCENTAGE_RUN_TIME_DATA:
    "NewDashboardReact/discount_in_per_updated_data",
  AVG_SALE_VALUE: "DashboardReactApi/avg_sale_value",
  AVG_SALE_VALUE_HOURLY: "DashboardReactApi/avg_sale_value_hourly",
  AVG_ITEM_SALE: "DashboardReactApi/avg_item_sale",
  AVG_ITEM_SALE_HOURLY: "DashboardReactApi/avg_item_sale_hourly",
  GET_PERMISSIONS: "UserController/get_permissions",
  GET_PERMISSION_PRESET: "permission/get_permission_preset",

  CREATE_PERMISSION_PRESET: "permission/create_permission_preset",
  UPDATE_PERMISSION_PRESET: "permission/update_permission_preset",
  DELETE_PERMISSION_PRESET: "permission/delete_permission_preset",

  UPDATE_IMPORT_PREFS: "UserController/update_merchant_import_prefs",
  GET_IMPORT_PREFS: "UserController/get_import_prefs",
  // DISCOUNT_CHART_NEW: "ReportingReactapi/discount_api_new",
  // PERCENTAGE_DISCOUNT_CHART_NEW: "NewDashboardReact/discount_in_per_api_new",
  // NEW REPORTS API ENDPOINTS
  REPORTS_DASHBOARD_API: "api/reports/dashboard",
  REPORTS_SALES_COUNT_API: "api/reports/sales_count_api",
  REPORTS_REVENUE_DATA_API: "api/reports/revenue_data_api",
  REPORTS_GROSS_PROFIT_API: "api/reports/gross_profit_api",
  REPORTS_GROSS_PROFIT_API_HOURLY: "api/reports/gross_profit_api_hourly",
  REPORTS_CUSTOMER_COUNT_API: "api/reports/customer_count_api",
  REPORTS_CUSTOMER_COUNT_API_HOURLY: "api/reports/customer_count_api_hourly",
  REPORTS_AVG_SALES_VALUE: "api/reports/avg_sales_value",
  REPORTS_AVG_ITEM_SALE: "api/reports/avg_item_sale",
  REPORTS_TOP_SOLD_PRODUCTS: "api/reports/top_sold_products",
  REPORTS_DISCOUNT_AMOUNT: "api/reports/discount_api_new",
  REPORTS_DISCOUNT_PERCENTAGE: "api/reports/discount_in_per_api_new",
  RECENT_ACTIVITY: "api/reports/get-recent-activity",
  // Report Sync (super admin) — runs scripts/refresh_php_snapshot.py on the reports API
  REPORT_SYNC_START: "api/report-sync/start",
  REPORT_SYNC_STATUS: "api/report-sync/status",
  REPORT_SYNC_CANCEL: "api/report-sync/cancel",
  // Report detail API
  REPORTS_RENEVUE_OUTLET_RECORD: "api/reports/revenue_data_outlet_report",
  REPORTS_STORE_AVG_ITEM_SALES_REPORT: "api/reports/avg_item_sale_report",
  REPORTS_STORE_AVG_SALES_REPORT: "api/reports/avg_sale_value_report",
  REPORTS_STORE_DISCOUNTED_REPORT: "api/reports/store_discounted_report",
  REPORTS_CUSTOMER_DISCOUNT_REPORT: "api/reports/customer_count_store_report",
  REPORTS_GROSS_PROFIT_REPORT: "api/reports/store_gross_profit_api",
  REPORTS_STORE_SALES_COUNT_REPORT: "api/reports/store_sales_count_api",
  REACT_APP_LOCATION_REPORT_API_URL: "api/reports/location-sales/locations",


  // Top Sales Person API
  TOP_SALES_PERSON: "NewDashboardReact/top_sales_people",



  LOTTERY_ACTIVITY_REPORT: "backend_report/lottery_activity_report",

  // Defaults API Calls
  LIST_ALL_Defaults: "DefaultReactapi/Default_list",
  ADD_DEFAULTS: "DefaultReactapi/AddDefaultMenu",
  EDIT_DEFAULTS: "DefaultReactapi/updateDefaultMenu",
  UPDATE_DEFAULTS: "DefaultReactapi/updateDefaultMenuForShow",
  DEFAULTDATA: "DefaultReactapi/DefaultData_list",
  DELETE_SINGLE_DEFAULTS: "DefaultReactapi/deleteMenu",
  DELETE_MULTI_DEFAULTS: "DefaultReactapi/deleteSelectedDefaults",
  UPDATE_ZOHO_SETTINGS: "Zoho_pk/updateZohoSetting",

  //Attributes API Calls
  LIST_ALL_ATTRIBUTES: "Varient_react_api/varients_list",
  ADD_ATTRIBUTE: "Varient_react_api/add_varient",
  // New: delete an attribute. Pending backend implementation per
  // docs/new-inventory-schema.md (soft vs hard delete is a backend decision).
  DELETE_ATTRIBUTE: "Varient_react_api/delete_varient",

  // Audit Log
  AUDIT_LOG_LIST: "AuditLogapi/list",
  AUDIT_LOG_SEARCH_PRODUCT: "AuditLogapi/search_product",
  AUDIT_LOG_ACTORS: "AuditLogapi/actors",
  AUDIT_LOG_EXPORT_REQUEST: "AuditLogapi/export_request",
  AUDIT_LOG_EXPORT_JOBS: "AuditLogapi/export_jobs",


  //SMS
  // SMS_DESCRIPTION:"https://n8n.quickvee.us/webhook/c3e3a2cb-ae48-4d7d-8cba-c85ca245af95",
  SMS_DESCRIPTION: "https://api.ai.quickvee.com/campaign/rewrite",

  // Ask-AI
  ASK_AI: "ChatController/doAjaxQuery",
  // QUICK_AI: "http://localhost:8000/query",
  QUICK_AI: "https://dev-api-ci.quickvee.us:8443/query",

  // Chatbot API — always POST under /python:
  //   /python/chatbot
  //   /python/chatbot/po/upload
  //   /python/chatbot/po/action
  //   /python/chatbot/po/save

  CHATBOT_SEND_MESSAGE: "chatbot",
  CHATBOT_PO_UPLOAD: "chatbot/po/upload",
  CHATBOT_PO_ACTION: "chatbot/po/action",
  CHATBOT_PO_SAVE: "chatbot/po/save",

  //Importdata API Calls
  IMPORT_DATA: "Import_data_api/import",
  IMPORT_DATA_ADVANCE: "Import_data_api/import_merchant",

  // Mix and Match Pricing
  ADD_MIX_MAX_PRICING_DEAL: "React_max_purchase_api/add_mix_match_pricing",
  MIX_MAX_PRICING_DEALS_LIST: "React_max_purchase_api/mix_match_pricing_list",
  DELETE_MIX_MAX_PRICING_DEAL:
    "React_max_purchase_api/delete_mix_match_pricing",
  ENABLE_DISABLE_MIX_MAX_PRICING_DEAL:
    "React_max_purchase_api/enable_mix_match_pricing",

  //Loyalty Program
  LOYALTY_PROGRAM_LIST: "LoyaltyProgramReactAPI/loyalty_program_list",
  GET_LOYATY_DATA_COUNT: "LoyaltyProgramReactAPI/loyalty_program_count",
  ADJUST_LOYALTY_POINTS: "LoyaltyProgramReactAPI/adjust_loyalty_points",
  ADJUST_LOYALTY_POINTS_TRANSACTION: "Loyalty_program_api/loyality_point_transaction",
  ADJUST_STORE_CREDIT_TRANSACTION: "Loyalty_program_api/store_credit_transaction",

  // Order API Calls (Offline and Online)
  LIST_ALL_IN_STORE_ORDER: "api/orderoffline",
  LIST_ALL_ONLINE_STORE_ORDER: "api/newOrder",
  LIST_ALL_STORE_ORDER_LIST: "Order_list_api/all_order_list",
  LIST_ALL_STORE_ORDER_LIST_NEW: "orders-management-new-ui/order_list", // new order list api
  CLOSE_ORDER_COLLECT_CASH: "Order_list_api/close_order_collectCash",
  ADD_EDIT_PERMISSION_LIST: "Main_permission/save_main_permission_api",
  FETCH_PERMISSION_LIST: "Main_permission/main_permission_list",

  //Storesettings API Calls

  EMPLOYEE_LIST: "Store_setting_react_api/employee_list",
  EMPLOYEE_LIST_V2: "Store_setting_react_api/employee_list_v2",
  ADDEDIT_EMPLOYEE: "Store_setting_react_api/addEdit_employee",
  SEND_INVITATION_EMPLOYEE: "UserController/send_invitation_employee",
  RESET_PASSWORD_EMPLOYEE: "Store_setting_react_api/reset_password_employee",
  DELETE_EMPLOYEE: "Store_setting_react_api/delete_employee",
  RESTORE_EMPLOYEE: "Store_setting_react_api/restore_employee",
  FOREVER_DELETE_EMPLOYEE: "Store_setting_react_api/forever_delete_employee",
  GET_ALL_MANAGER_STORES: "Store_setting_react_api/getManagerStores",
  // EMPLOYEE_LIST:"App/employee_list",

  EMPLOYEE_DATA: "Store_setting_react_api/getEmployeeByEmpid",
  PERMISSIONS_LIST: "Store_setting_react_api/permission_list",
  GET_NOTIFICATIONS: "Notification/get_notifications",
  MARK_NOTIFICATION_READ: "Notification/mark_notification_read",
  UPDATE_PERMISSION: "Store_setting_react_api/update_Employee_permission",
  UPDATE_PERMISSION_BULK:
    "Store_setting_react_api/bulk_update_employee_permissions",
  // Store Setting - RegisterSettings api
  GET_REGISTER_SETTINGS_DATA: "ProfileReact_setup/inventory_register_setting",
  UPDATE_REGISTER_SETTINGS: "ProfileReact_setup/register_setting",

  // Store Setting options api
  GET_STORE_OPTIONS_DATA: "Store_setting_react_api/get_store_options_data",
  UPDATE_STORE_OPTION: "Store_setting_react_api/update_store_option",

  // Update Store Setting options api
  // UPDATE_STORE_OPTIONS_DATA: "Store_setting_api/update_store_options_data",
  UPDATE_STORE_OPTIONS_DATA: "Store_setting_react_api/update_store_option",
  UPDATE_STORE_INFO: "Store_setting_react_api/update_store_info",
  INVENTORY_REPORT_EXPORT: "InventoryReportPk/inventory_report_export",
  //Coupon API Calls
  COUPON_LIST: "CouponReactApi/get_coupon_details",
  COUPON_STATUS_UPDATE: "CouponReactApi/show_online",
  COUPON_DELETE: "CouponReactApi/delete_coupon",
  COUPON_TITLE_CHECK: "CouponReactApi/check_coupon_title",
  // COUPON_DETAILS_ID_CHECK: "Couponapi/get_edit_coupon_details",
  COUPON_DETAILS_ID_CHECK: "CouponReactApi/get_coupon_by_id",
  EDIT_COUPON: "CouponReactApi/edit_coupon",
  ADD_COUPON: "CouponReactApi/add_coupon",

  //New Coupon
  NEW_COUPON_LIST: "Couponapi/get_coupon_list",
  NEW_COUPON_LIST_NEW: "Couponapi/get_coupon_list_new",
  NEW_COUPON_STATUS_UPDATE: "Couponapi_live/update_coupon_status",
  NEW_COUPON_DELETE: "Couponapi_live/delete_coupon",
  NEW_EDIT_COUPON: "Couponapi_live/edit_coupon",
  NEW_ADD_COUPON: "Couponapi_live/add_coupon",

  // System Access API Calls Listing and Update
  LIST_ALL_SYSTEM_ACCESS: "api/SettingsReact_api/system_access",
  UPDATE_SYSTEM_ACCESS: "api/SettingsReact_api/update_system_access",
  END_DAY_ACTUAL_AMT: "api/SettingsReact_api/day_end_actual_amt",
  CHECK_END_DAY: "api/SettingsReact_api/check_eod",

  //Inventory
  LIST_INVENTORY: "api/SettingsReact_api/inventory_list",
  // UPDATE_INVENTORY: "api/SettingsReact_api/update_inventory_info",
  UPDATE_INVENTORY: "StoreReact_setting_api1/update_inventory_info",

  // Store setup
  UPDATE_STORE_SETUP: "Store_setting_react_api/update_store_setup",

  // get Store Setting alerts list api
  GET_STORE_ALERTS_DATA: "Store_setting_react_api/store_alerts_list",

  // get Store Setting alerts list api
  UPDATE_STORE_ALERTS_DATA: "StoreReact_setting_api1/update_store_alerts",

  // Get Store Setting Receipt List and Update API
  GET_STORE_RECEIPT_DATA: "StoreReact_setting_api/get_receipt_list",
  UPDATE_RECEIPT_INFO_DATA: "StoreReact_setting_api/update_receipt_info_list",

  // Purchase Order API Calls
  LIST_ALL_PARCHASE: "Purchase_ordersReactApi/purchase_order_list",
  PURCHASE_ORDER_COUNT: "Purchase_ordersReactApi/purchase_order_count",
  SAVE_PO: "Purchase_ordersReactApi/save_po",
  AUTO_PO_LIST: "Purchase_ordersReactApi/auto_po_list",
  PURCHASE_ORDER_DETAILS_BY_ID: "Purchase_ordersReactApi/get_po_by_id",
  VOID_PO: "Purchase_ordersReactApi/void_po",
  RECEIVE_PURCHASE_ORDER_ITEMS: "Purchase_ordersReactApi/recieve_po",
  UPDATE_PO: "Purchase_ordersReactApi/update_po",
  EMAIL_PO: "Purchase_ordersReactApi/email_po",
  DELETE_PO_ITEM: "Purchase_ordersReactApi/delete_po_item",

  // New Purchase Order API Calls
  NEW_PURCHASE_ORDER_LIST: "new_purchase_orders_api/new_purchase_orders_list",
  NEW_PURCHASE_ORDER_LIST_COUNT:
    "new_purchase_orders_api/new_purchase_orders_list_count",
  NEW_PURCHASE_ORDER_COUNT: "new_purchase_orders_api/new_purchase_orders_count",
  // NEW_PURCHASE_ORDER_PRODUCT_LIST:
  //   "new_purchase_orders_api/new_purchase_orders_product_list",
  NEW_PURCHASE_ORDER_PRODUCT_LIST:
    "new_purchase_orders_api/new_purchase_orders_product_list_v2",
  NEW_PURCHASE_ORDER_PRODUCT_BY_UPC:
    "new_purchase_orders_api/new_purchase_order_product_by_upc",
  NEW_PURCHASE_ORDER_VENDOR_LIST:
    "new_purchase_orders_api/new_purchase_orders_vendor_list",
  NEW_PURCHASE_ORDER_GENERATE_PO_NUMBER:
    "new_purchase_orders_api/generate_po_number",
  NEW_PURCHASE_ORDER_ADD: "new_purchase_orders_api/add_new_purchase_order",
  NEW_PURCHASE_ORDER_ADD_AND_RECEIVE:
    "new_purchase_orders_api/add_and_receive_new_purchase_order",
  NEW_PURCHASE_ORDER_ADD_FROM_CSV:
    "new_purchase_orders_api/add_new_purchase_orders_from_csv",
  NEW_PURCHASE_ORDER_DELETE:
    "new_purchase_orders_api/delete_new_purchase_order",
  NEW_PURCHASE_ORDER_VOID:
    "new_purchase_orders_api/void_new_purchase_order",
  NEW_PURCHASE_ORDER_DETAILS:
    "new_purchase_orders_api/new_purchase_order_details",
  NEW_PURCHASE_ORDER_UPDATE:
    "new_purchase_orders_api/update_new_purchase_order_items",
  NEW_PURCHASE_ORDER_UPDATE_SOH:
    "new_purchase_orders_api/update_new_purchase_order_items_soh",
  NEW_PURCHASE_ORDER_RECEIVE:
    "new_purchase_orders_api/receive_new_purchase_order",
  NEW_PURCHASE_ORDER_EMAIL:
    "new_purchase_orders_api/send_vendor_email",

  // LIST_ALL_PARCHASE: "Purchase_ordersReactApi_PK/purchase_order_list",
  // PURCHASE_ORDER_COUNT: "Purchase_ordersReactApi_PK/purchase_order_count",
  // SAVE_PO: "Purchase_ordersReactApi_PK/save_po",
  // AUTO_PO_LIST: "Purchase_ordersReactApi_PK/auto_po_list",
  // PURCHASE_ORDER_DETAILS_BY_ID: "Purchase_ordersReactApi_PK/get_po_by_id",
  // VOID_PO: "Purchase_ordersReactApi_PK/void_po",
  // RECEIVE_PURCHASE_ORDER_ITEMS: "Purchase_ordersReactApi_PK/recieve_po",
  // UPDATE_PO: "Purchase_ordersReactApi_PK/update_po",
  // EMAIL_PO: "Purchase_ordersReactApi_PK/email_po",
  // DELETE_PO_ITEM: "Purchase_ordersReactApi_PK/delete_po_item",
  ADD_NEW_ZOHO_CUSTOMER: "Zoho_pk/create_new_zoho_customer",

  // Taxes API Calls
  ADD_TAXES: "Taxes_react_api/add_Tax",
  UPDATE_TAXES: "Taxes_react_api/update_Tax",
  LIST_ALL_TAXES: "Taxes_react_api/Taxes_list",
  DELETE_SINGLE_TAXE: "Taxes_react_api/delete_tax",
  TAXE_CATEGORY_LIST: "Taxes_react_api/Taxes_category_list",
  FETCH_DATA_TAXE: "Taxes_react_api/edit_taxes",

  // All Reports API
  CHECKID_VARIFICATION_REPORT_LIST:
    "ReportingReactapi/checkID_varification_report_list",

  // for daily Report
  //LIST_DAILY_REPORT: "ReportingReactapi/daily_total_report",

  LIST_DAILY_REPORT: "api/reports/daily_total",

  // NEW_ITEM_CREATED_BETWEEN_LIST:
  //   "ReportingReactapi/new_item_created_between_list",

  TRANSFER_MERCHANT_TO_NEW_OWNER:
    "UserController/move_merchants_to_new_location",

  TOP_SALLER_REPORT: "ReportingReactapi/top_seller_10",
  // Fact-table (Python/ClickHouse) replacement for TOP_SALLER_REPORT.
  // Use with REPORTS_BASE_URL, not BASE_URL. Ranks across every outlet in
  // outlet_ids instead of a single merchant.
  TOP_SALLER_REPORT_FACT_API: "api/reports/top_seller_fact",
  // INSTANT_ACTIVITY_REPORT: "ReportingReactapi/instant_po_activity_report",

  //Employee List
  LIST_ALL_EMPLOYEE: "ReportingReactapi/employee_list",
  CHECK_EMAIL_VALIDATION: "UserController/check_admin_employee_email",
  CHECK_PIN_VALIDATION: "UserController/check_emp_pin",

  //INVENTORY_EXPORT
  INVENTORY_EXPORT: "ExportInventory_api/queueInventoryExport",
  // INVENTORY_EXPORT: "ExportInventory_api/exportCSV",
  LIST_ALL_MERCHANTS: "ExportInventory_api/merchants_list",
  // Superadmin-managed stores restricted from inventory export
  INVENTORY_EXPORT_RESTRICTIONS_LIST: "ExportInventory_api/export_restrictions_list",
  UPDATE_INVENTORY_EXPORT_RESTRICTIONS: "ExportInventory_api/update_export_restrictions",
  INVENTORY_EXPORT_RESTRICTION_STATUS: "ExportInventory_api/export_restriction_status",
  LIST_ALL_MERCHANTSLOC: "places/merchants_list",


  //Customer Export
  CUSTOMER_EXPORT: "Export_merchant_reports/export_customer_report",
  //Order Wise Export
  ORDER_WISE_EXPORT: "Export_merchant_reports/export_order_wise_report",
  //Item Wise Export
  ITEM_WISE_EXPORT: "Export_merchant_reports/export_item_wise_report",

  //Tip Report Export
  TIP_REPORT_EXPORT: "backend_report/merchant_wise_employee_tip_report",

  //Access Purchase Order Report Export
  PURCHASE_ORDER_REPORT_EXPORT: "export_merchant_reports/received_purchase_orders",

  //Sales by Category Per Employee Export
  SALES_BY_CATEGORY_PER_EMPLOYEE_REPORT_EXPORT: "backend_report/category_wise_employee_sales_report",

  //Sales by Tender Export
  SALES_BY_TENDER_REPORT_EXPORT: "Export_merchant_reports/export_sales_by_tendor_report",

  //INVENTORY_EXPORT
  INVENTORY_DUPLICATE: "Inventory_duplicate_api/duplicate_inventory",
  SETTINGS_DUPLICATE: "Inventory_duplicate_api/duplicate_setting",

  LIST_PAYMENT_METHOD_REPORT: "ReportingReactapi/credit_card_sales_report",

  // });

  // For Online Order Refund Report
  REFUND_LOGS_REPORT: "Order_list_api/refund_logs_report",
  REFUND_LOGS_REPORT_COUNT: "Order_list_api/refund_logs_report_count",


  // for item sales report
  GET_ITEMWISE_SALE_LIST: "ReportingReactapi/get_itemwise_sale_list",
  GET_TOP_PRODUCT_SOLD: "ReportingReactapi/top_product_sold",
  NEW_ITEMWISE_SALE_LIST: "ReportingReactapi/new_item_sale_report",
  ITEMS_SALES_REPORT_API: "api/reports/items_sales_report_api_fact",
  // Sales by Item's own CSV export, sourced from the SAME fact table as
  // ITEMS_SALES_REPORT_API above - distinct from ITEMS_SOLD_REPORT_CONSOLIDATED_API
  // below (report_item_sales_daily snapshot), which stays wired to whatever
  // else still uses it (Item Sold Report, Category Sold Report exports).
  ITEMS_SALES_REPORT_EXPORT_API: "api/reports/items_sales_report_api_fact_export",
  ITEMS_SOLD_REPORT_CONSOLIDATED_API: "api/reports/items_sold_report_consolidated",//"api/item-sold/csv",
  ITEMS_SOLD_REPORT_NEW_API: "api/reports/items_sales_report_api", //"api/item-sold/json",
  ITEMS_SOLD_STOCK_TOTAL_API: "api/reports/items_sales_report_stock_total",
  ITEM_SOLD_FILTER_OPTIONS_API: "api/reports/item_sold_filter_options",
  // Distinct name from CATEGORY_SALES_REPORT_API below (pre-existing, points at
  // the older NewDashboardReact/category_sales_report_list endpoint) — a
  // duplicate object key here would silently resolve to whichever is defined
  // last, which is exactly the bug this name avoids.
  //CATEGORY_SOLD_REPORT_API: "api/reports/category_sales_report_api",
  CATEGORY_SOLD_REPORT_API: "api/reports/category_sales_report_api_fact",

  CATEGORY_SOLD_REPORT_CONSOLIDATED_API: "api/reports/category_sold_report_consolidated",
  // PO Products Report (RNR) — same endpoint serves the page (paged JSON) and
  // the export (format=csv).
  PO_PRODUCTS_REPORT_API: "api/reports/po_products_report",
  // ITEM_SOLD_JSON_API: "api/item-sold/json",
  PAY_IN_REPORT: "ReportingReactapi/pay_in_report",
  DROP_CASH_REPORT: "ReportingReactapi/drop_cash_report",
  EMPLOYEE_SALES_PER_CATEGORY_REPORT: "ReportingReactapi/emp_category_sale",
  // NET_SALES_BY_EMPLOYEE_REPORT:
  //   "NewEmployeeReport/employee_net_sale_with_items",
  NET_SALES_BY_EMPLOYEE_REPORT: "NewEmployeeReport/employee_net_sale_with_items_v2", //new Employee => Sales by Item per Employee

  // For Discount Sales Report
  DISCOUNT_SALES_TABLE_LIST: "NewDashboardReact/discount_sales_report_list",
  TOP_SALE_DISCOUNT_LIST: "NewDashboardReact/top_sale_discount_sold",
  TOP_DISCOUNTS_BY_AMOUNT: "NewDashboardReact/top_discounts_by_amount",
  // Fact-table (Python/ClickHouse) replacement for all THREE routes above.
  // Use with REPORTS_BASE_URL, not BASE_URL. It returns the table payload and
  // both chart payloads from one scan, and unlike the PHP routes it actually
  // honours outlet_ids (multi-location) instead of always reporting on the
  // logged-in store.
  DISCOUNT_REPORT_FACT_API: "api/reports/discount_report_fact",

  // For Vendor - Sales Report
  VENDOR_SALES_REPORT: "Vendor_new_report_api/vendor_sale_report",

  // Sales Report (Category report)
  GET_TOP_CATEGORY_BY_QUANTITY_SOLD:
    "NewDashboardReact/top_category_by_qty_sold",
  GET_TOP_CATEGORY_BY_SALES_AMOUNT:
    "NewDashboardReact/top_category_by_sales_amt",
  GET_TOP_CATEGORY_SALES_REPORT_LIST:
    "NewDashboardReact/category_sales_report_list",
  CATEGORY_SALES_REPORT_API: "api/NewDashboardReact/category_sales_report_list",
  DAILY_SALES_TOTALS_API: "api/reports/daily_sales_totals_fact",
  HOURLY_SALES_REPORT_API: "api/reports/hourly_sales_fact",
  UPDATE_SINGLE_STORE: "UserController/update_single_store",
  HOURLY_SALES_REPORT_API: "api/reports/hourly_sales_fact",
  HOURLY_SALES_SAVE_SETTINGS_API: "api/reports/hourly_sales/save-settings",
  HOURLY_SALES_LOAD_SETTINGS_API: "api/reports/hourly_sales/load-settings",

  //Order Type

  LIST_ALL_ORDER_TYPE: "ReportingReactapi/order_type",
  LIST_ALL_ORDER_TYPE_NEW: "ReportingReactapi/order_type_new",
  // Fact-table (Python/ClickHouse) replacement for LIST_ALL_ORDER_TYPE_NEW.
  // Use with REPORTS_BASE_URL, not BASE_URL. Unlike the PHP route it actually
  // honours outlet_ids (multi-location) and nets refunds whose order was placed
  // outside the reported window.
  ORDER_TYPE_NEW_FACT_API: "api/reports/order_type_new_fact",

  LIST_TAXES_REPORT: "ReportingReactapi/taxes_report",
  NEW_TAXES_REPORT: "Sale_summary_api/tax_report",

  LIST_CURRENT_INVENTORY_REPORT: "ReportingReactapi/inventory_report",
  ITEM_SALES_PROFIT_REPORT: "ReportingReactapi/item_sale_profit_report",
  Product_Profitability_REPORT: "ReportingReactapi/employee_avg_order_value",

  //Super Admin - Permission
  LIST_ALL_PERMISSION: "api/Create_permission_api/permission_list",
  ADD_UPDATE_PERMISSION: "api/Create_permission_api/save_sub_permission",
  DELETE_SINGLE_PERMISSION: "api/Create_permission_api/deleteperm",

  // Store Order List API
  GET_STORE_ORDER_DATA: "Store_order_api/get_store_order_data",
  GET_STORE_ORDER_DATA_COUNT: "Store_order_api/get_store_order_count",

  // Export Order Count Data
  EXPORT_ORDER_COUNT_DATA: "Store_order_api/export_order_count_data",

  // CATEGORY DUPLICATE
  LIST_ALL_CATEGORIES_MECHANT_ID: "Category_duplicate_api/get_category",
  CATEGORY_INVENTORY_DUPLICATE: "Category_duplicate_api/category_inventory",

  // PRODUCT DUPLICATE
  LIST_ALL_PRODUCTS: "Product_Duplicate_api/get_product",
  PRODUCT_INVENTORY_DUPLICATE:
    "Product_Duplicate_api/product_inventory_duplicate",

  // REPORT_BY_SALES_PERSON
  REPORT_BY_SALES_PERSON: "ReportingReactapi/report_by_sales_person",
  GIFT_CARD_REPORT: "ReportingReactapi/gift_card_report_api",
  GIFT_CARD_REPORT_COUNT: "ReportingReactapi/gift_card_report_count",

  DETAIL_CATEGORY_SALE_REPORT: "vendor_report_api/detailed_category_sale",
  // Fact-table (Python/ClickHouse) replacement for DETAIL_CATEGORY_SALE_REPORT.
  // Use with REPORTS_BASE_URL, not BASE_URL. Reports across every outlet in
  // outlet_ids, and its per-category totals reconcile with
  // CATEGORY_SALES_REPORT_FACT_API.
  DETAIL_CATEGORY_SALE_REPORT_FACT_API: "api/reports/detailed_category_sale_fact",

  //  Sales Report List API
  // SALES_REPORT_LIST: "vendor_report_api/sales_report",
  // SALES_REPORT_LIST: "ReportingReactapi/new_sale_overview",
  SALES_REPORT_LIST: "Sale_summary_api/new_sale_overview",
  //SALES_REPORT_LIST_REPORTS: "api/reports/sales_report_api",
  SALES_REPORT_LIST_REPORTS: "api/reports/sales_report_api_fact",
  OLD_SALES_REPORT_LIST: "vendor_report_api/sales_report",
  // tip report list api
  TIP_REPORT_LIST: "ReportingReactapi/tip_report",
  NEW_TIP_REPORT_LIST: "backend_report/online_order_tip_report",
  NEW_TIP_REPORT_LIST_DETAIL: "backend_report/online_order_tip_report_list",
  //coupon report api

  COUPON_REPORT_LIST: "ReportingReactapi/coupon_report",
  // Fact-table (Python/ClickHouse) replacement for the route above.
  // Use with REPORTS_BASE_URL, not BASE_URL. It returns coupon_list AND
  // coupon_report_data from one call, honours outlet_ids (multi-location)
  // instead of always reporting on the logged-in store, groups rows by the
  // business date rather than the raw calendar date, and treats a blank/'All'
  // coupon_code as no filter so a deleted coupon's usage can no longer be
  // hidden by the dropdown.
  COUPON_REPORT_FACT_API: "api/reports/coupon_report_fact",
  // Coupon Name dropdown options: every coupon configured at any outlet in
  // outlet_ids. Use with REPORTS_BASE_URL. Called whenever the Outlet picker
  // changes, before Search.
  COUPON_FILTER_OPTIONS_API: "api/reports/coupon_filter_options",
  // Owner Report (Python/ClickHouse). Use with REPORTS_BASE_URL. Every
  // selected store (outlet_ids) for one business day or a from-to range; the
  // export route returns the same figures as a three-sheet .xlsx.
  OWNER_REPORT_API: "api/reports/owner_report",
  OWNER_REPORT_EXPORT_API: "api/reports/owner_report/export",
  // Whether this login may see the Owner Report: superadmins always, a merchant
  // only once a superadmin has enabled it in Owner Report Setup.
  OWNER_REPORT_ACCESS_API: "api/reports/owner_report/access",

  // GET_ORDER_SUMMERY_DETAILS:'Orders/order_details',
  SALES_REPORT_LIST_REPORTS: "api/reports/sales_report_api_fact",
  // -------------------------
  // ---------------------
  ADD_MERCHAN_EMPLOYEE: "UserController/add_admin",
  GET_MERCHAN_STATE: "UserController/add",
  GET_ADMIN_DATA: "UserController/get_user", // get merchant admin record
  ADMIN_CHECK_USER: "UserController/check_user", // check email pending
  CHECK_ADMIN_EMAIL: "UserController/check_user_type", //check admin email
  ADMIN_GET_CUSTOMER: "UserController/get_customer", // get customer data
  GET_CUSTOMER_COUNT: "UserController/get_customer_count", // get customer count
  // GET_EDIT_CUSTOMER:'UserController/edit_customer',
  // GET_EDIT_CUSTOMER:'UserController/edit_customer',
  GET_MANAGER_LISTING: "Manager_react/manager_list",
  GET_MANAGER_RECORD: "UserController/maneger_view", // manager view
  GET_MANAGER_RECORD_COUNT: "UserController/maneger_view_count", // manager view
  ADD_MANAGER: "Manager_react/add_update_manager", // manager view
  DELETE_MANAGER: "Manager_react/delete_manager",
  GET_ADMIN_RECORD: "UserController/admin_view", // admin view data
  GET_ADMIN_RECORD_COUNT: "UserController/admin_view_count", // admin records count
  GET_MANAGER_MERCHANT: "UserController/get_manager_merchant", // get manager merchant
  GET_ADMIN_MERCHANT: "UserController/get_merchant", // give admin merchant
  GET_EDIT_ADMIN: "UserController/edit_admin", // edit admin
  UPDATE_ADMIN_RECORD: "UserController/update_admin", //update admin
  GET_EDIT_CUSTOMER: "UserController/edit", // adit customer
  GET_UPDATE_CUSTOMER: "UserController/update", // update customer
  GET_VERIFIED_MERCHANT: "UserController/getUnverifiedMerchant", //get verified and unverified merchant
  GET_MERCHANTS: "UserController/getMerchants", //get verified and unverified merchant
  GET_VERIFIED_MERCHANT_COUNT: "UserController/getUnverifiedMerchantCount", //get verified and unverified merchant count
  GET_ADD_ADMIN: "UserController/insert_admin", //add admin
  GET_UPDATE_MERCHANT: "UserController/merchant_update",
  GET_Edit_STORE_INFO: "UserController/store_info",
  // UPDATE_STORE_INFO: "UserController/createMenuLink",
  GET_MERCHANT_DATA: "UserController/getadmins",

  // vendor Report List API
  VENDORS_REPORT_LIST: "vendor_report_api/vendor_list",
  EDIT_VENDOR_DATA: "Vendor_api/edit_vendor",
  UPDATE_VENDOR_DATA: "Vendor_api/update_vendor",
  ADD_VENDOR_DATA: "Vendor_api/add_vendor",
  GET_VENDOR_DETAILS: "Vendor_api/vendor_details",
  DELETE_SINGLE_VENDOR_DATA: "Vendor_api/delete_vendor",
  GET_VENDORS_DATA_COUNT: "vendor_report_api/vendor_list_count",
  VENDOR_EMAIL_VALIDATION: "Vendor_api/vendor_email_check",

  //New Vendor API calls
  NEW_VENDORS_LIST: "Vendor_api_new/vendor_list",
  NEW_NO_PRODUCT_VENDORS_LIST: "Vendor_api_new/vendors_with_no_product",
  VENDORS_ADD: "Vendor_api_new/create_vendor",
  VENDORS_EDIT: "Vendor_api_new/update_vendor",
  VENDORS_DELETE: "Vendor_api_new/delete_vendor",

  // Vendors Sales List API
  VENDORS_SALES_REPORT: "vendor_report_api/vendors_sales_report",

  // Vendors List for sales report API
  VENDORS_LIST: "vendor_report_api/get_vendor_list",

  // Order Refund Report
  ORDER_REFUND_REPORT: "vendor_report_api/order_refund_report",
  ORDER_REFUND_COUNT: "vendor_report_api/order_refund_count",
  REFUND_REPORT: "ReportingReactapi/refund_report",
  REFUND_REPORT_COUNT: "ReportingReactapi/refund_report_count",

  // Vendors API calls
  LIST_ALL_VENDORS: "Vendor_api/vendor_list",

  // vendors status update

  STATUS_UPD_VENDORS: "Vendor_api/onlineAvail",

  // GET_ORDER_SUMMERY_DETAILS

  GET_ORDER_SUMMARY_DETAILS: "Orders/order_details",

  // NewsLetter List API
  NEWS_LETTER_LIIST: "vendor_report_api/newsletter",

  // GET_REORDER_INVENTORY_LIST: "ReportingReactapi/get_reorder_inventory_list",

  // PRODUCTS
  PRODUCTS_LIST: "Product_api_react/Products_list",
  // Edit product "Copy to stores": only stores where this product already exists.
  GET_SYNC_STORES: "Product_api_react/get_sync_stores",
  // Facet counts for the Channels filter (elastic service only): returns
  // { channel_counts: { pickup, delivery } } for the current filter set.
  PRODUCTS_LIST_CHANNEL_COUNT: "Product_api_react/Products_list_channel_count",
  LOTTERY_PRODUCT_LIST: "product/lottery",
  ALL_PRODUCTS_LIST: "Productapi/products_list",
  ALL_PRODUCTS_LIST_WITH_VARIANTS: "Product_api_react/variant_list",
  PRODUCT_DEFAULT_IMAGE: this.BASE_URL + "upload/products/MaskGroup4542.png",
  UPDATE_TYPE: "Product_api_react/update_type",
  MASS_INVENTORY_UPDATE: "Product_api_react/mass_update_inventory",
  BULK_UPDATE_VENDORS: "product_api_react/bulk_update_vendors",
  ALL_PRODUCTS_WITH_VARIANTS_LIST: "ReportingReactapi/variant_list_data",
  GET_STORES: "Productapi/get_stores",
  PRODUCT_SALES_HISTORY_COUNT: "Product_api_react/saleshistory_count",
  PRODUCT_SUGGESTION: "productapi/product_suggestion",
  PRODUCT_SALES_HISTORY: "Product_api_react/new_saleshistory",
  PURCHASE_ORDER_CREATE_PRODUCT: "Quickadd_product_react/quick_add_product_new",
  // The full product create — the same endpoint the New Product form posts
  // to. Used by the composite kit editor so a kit can be created with the
  // same field set as any other product, WITHOUT modifying a shared API.
  ADD_PRODUCT_FULL: "Product_api_react/add_product",
  // Adds ONE variant to an existing variant product without resending the
  // others (unlike edit_produt). Used by the PO "not found → add as variant" flow.
  ADD_SINGLE_VARIANT: "Product_api_react/add_single_variant",
  PRODUCT_DATA_BY_ID: "Product_api_react/get_productdata_ById",
  // Advisory price check against the promotions a product/variant is in
  // (BOGO, Mix & Match, item coupons). Read-only; see services/products/promotionPriceCheck.js.
  CHECK_PROMOTION_PRICE: "Product_api_react/check_promotion_price",
  // PRODUCT_SUGGESTION: "productapi/product_suggestion",
  // PURCHASE_ORDER_CREATE_PRODUCT: "Quickadd_product_react/quick_add_product_new",
  PRODUCTS_LIST_NODE: "products",
  PRODUCTS_LIST_WITH_TRANSFERS_NODE: "products/transfer-list",
  INVENTORY_TRANSFER_CREATE: "inventory/transfer",
  INVENTORY_TRANSFER_RESOLVE_DESTINATION: "inventory/transfers/resolve-destination",
  INVENTORY_TRANSFERS_LIST: "inventory/transfers",
  INVENTORY_TRANSFER_DETAIL: "inventory/transfers/detail",
  INVENTORY_TRANSFERS_SUMMARY: "inventory/transfers/summary",
  INVENTORY_TRANSFER_STATUS: "inventory/transfer/status",
  INVENTORY_TRANSFER_NOTES: "inventory/transfer/notes",
  INVENTORY_TRANSFER_SYNC: "inventory/transfers/sync",
  STORE_LIST: "store/list",


  // Composite items (Node backend — use with BASE_NODE_URL).
  // Mounted at /composite in quickvee-backend-node/router/route.js.
  COMPOSITE_SETTING: "composite/setting",
  COMPOSITE_SETTING_UPDATE: "composite/setting/update",
  COMPOSITE_LIST: "composite/list",
  COMPOSITE_LIST_COUNT: "composite/list_count",
  COMPOSITE_DETAIL: "composite/detail",
  COMPOSITE_MARK: "composite/mark",
  COMPOSITE_UNMARK: "composite/unmark",
  COMPOSITE_RECIPE_SAVE: "composite/recipe/save",
  COMPOSITE_WHERE_USED: "composite/where_used",
  COMPOSITE_OPERATION_PREVIEW: "composite/operation/preview",
  COMPOSITE_OPERATION_POST: "composite/operation/post",
  COMPOSITE_OPERATIONS: "composite/operations",
  COMPOSITE_OPERATIONS_COUNT: "composite/operations_count",
  COMPOSITE_OPERATION_DETAIL: "composite/operation/detail",
  COMPOSITE_CART_EXPAND: "composite/cart/expand",
  INVENTORY_COUNT_SYNC: "Inventory_count_sync/merchant_recompute",

  PRODUCT_DESCRIPTION: "https://api.ai.quickvee.com/ask_vee",

  //shiftsummary api

  GET_SHIFT_SUMMARY_LIST: "Reportingreactapi_pcr/shift_summary_report_list",

  //StoreSetup details  api

  GET_STORE_SETUP_LIST: "Settingapi/store_details",

  //All Orders API
  UPDATE_ORDER_STATUS: "Order_list_api/changeStatus_api",
  RESET_PASS_API: "Forget_pass/reset_pass_save",
  RESET_PASS_API_EMP: "Forget_pass/reset_pass_save_emp",

  // working hrs api
  UPDATE_WORKING_HRS_STATUS: "report_api/employee_work_hours1",

  // Employee work hours API
  // EMPLOYEE_WORK_HOURS: "Report_api/employee_work_hours1_api",
  EMPLOYEE_WORK_HOURS: "Report_api/employee_work_hours2_api",

  LOGIN_AUTHENICATE_API: "LoginApiReact/chk_merchant",
  LOGIN_AUTHENICATE2_API: "LoginApiReact/send_otp_session", //
  LOGIN_OTP_AUTHENTICATION: "LoginApiReact/chk_otp", //
  // LOGIN_OTP_SUBMIT_AUTHENTICATION: "LoginApiReact/create_session", //
  LOGIN_OTP_SUBMIT_AUTHENTICATION: "LoginApiReact/create_session", //
  // LOGIN_OTP_SUBMIT_AUTHENTICATION: "LoginApiReact/create_session_pk", //
  // One-time code handoff from the POS webview dashboard button — see loginWithCode.
  LOGIN_WITH_CODE: "LoginApiReact/login_with_code",
  // A code session switches store through a code for the target store (see switchStoreWithCode).
  WEB_LOGIN_CODE: "LoginApiReact/web_login_code",
  RESEND_OTP: "LoginApiReact/resend_otp",
  MANAGE_TRUSTED_DEVICES: "LoginApiReact/manage_trusted_devices",
  LOGIN_VIA_SUPERADMIN: "LoginApiReact/login_via_superadmin", //
  DASHBOARD_COUNT_STORE: "DashboardReactApi/all_orders_total_api", //
  DASHBOARD_TABLE_LIST: "DashboardReactApi/recent_online_orders_list",
  DELETE_SINGLE_STORE: "UserController/delete",
  GET_ORDER_SUMMERY_DETAILS: "Orders/order_details",
  UNAPPROVE_SINGLE_STORE: "UserController/unapprove",
  APPROVE_SINGLE_STORE: "UserController/approve",
  EXPORTCSV: "UserController/exportCSV",
  DISCOUNT_PER_PERSON: "Reportingreactapi_pcr/discount_per_sales_person_report",

  // For TimeSheet
  TIME_SHEET_LIST: "Timesheet_react_api/timesheet_list",
  TIME_SHEET_GETBREAKS: "Timesheet_react_api/getBreaks",
  ADD_TIME_SHEET: "Timesheet_react_api/addNewTimeclock",
  ADD_TIME_BREAK: "Timesheet_react_api/addBreak",
  DELETE_TIMESHEET: "Timesheet_react_api/delete_timeclock",
  DELETE_BREAK: "Timesheet_react_api/delete_breaks",

  CHANGE_PASSWORD_STORE: "Store_setting_react_api/change_password",
  // INVENTORY_LIST: "ReportingReactapi/JsonDataproductnew1",
  EMAIL_VARIFICATION: "LoginApiReact/reset_password_send",

  GET_STOCKTAKE_LIST: "Stocktake_react_api/stocktake_list",
  GET_STOCKTAKE_NEW_UI_LIST: "StocktakeNewUI/stocktake_list",
  STOCKTAKE_DASHBOARD_STATS: "StocktakeNewUI/stocktake_dashboard_stats",
  STOCK_ON_HAND_DASHBOARD_SUMMARY: "StockOnHand/dashboard_summary",
  STOCK_ON_HAND_LIST: "StockOnHand/list",
  STOCK_ON_HAND_WATCH: "StockOnHand/watch",
  STOCK_ON_HAND_LOCATION_DETAIL: "StockOnHand/location_detail",
  STOCK_ON_HAND_ADJUST_STOCK: "StockOnHand/adjust_stock",
  CREATE_STOCKTAKE_NEW_UI: "StocktakeNewUI/create_stocktake",
  STOCKTAKE_SAVE_COUNTS: "StocktakeNewUI/save_counts",
  STOCKTAKE_GET_DETAILS: "StocktakeNewUI/get_stocktake_details",
  STOCKTAKE_UPDATE_RECOUNT_FLAG: "StocktakeNewUI/update_recount_flag",
  STOCKTAKE_POST_ADJUSTMENT: "StocktakeNewUI/post_stocktake_adjustment",
  STOCKTAKE_VOID_STOCKTAKE: "StocktakeNewUI/void_stocktake",
  STOCKTAKE_REMOVE_ITEM: "StocktakeNewUI/remove_stocktake_item",
  STOCKTAKE_DELETE: "StocktakeNewUI/delete_stocktake",
  STOCKTAKE_EMAIL: "Stocktake_react_api/email_stocktake",
  CREATE_UPDATE_STOCKTAKE: "Stocktake_react_api/create_update_stocktake",

  VOID_STOCKTAKE: "Stocktake_react_api/void_stocktake",
  STOCKTAKE_LIST_COUNT: "Stocktake_react_api/stocktake_count",

  SYNC_DATA: "InventoryReact/syncOI",
  // SYNC_DATA: "InventoryReact_pk/syncOI",
  SEND_FOR_APPROVAL: "Product_api_react/send_approval",

  VENDOR_UPDATE_DETAILS: "vendor_api/update_details",
  CHECK_EXIST_STORENAME: "UserController/check_merchant",
  CHECK_EXISTING_PIN: "StoreReact_setting_api/check_pin",

  // Support Details
  SUPPORT_DETAILS_LIST: "Support_details_react_api/view_support_details",
  SUPPORT_DETAILS_EDIT: "Support_details_react_api/update_support_details",
  Dashboard_URL_REDIRECT: "Dashboard/login_via_superadmin",
  PURCHASE_ORDER_API: "Purchase_orders_api/po_list",

  ORDER_TYPE_ORDER_LIST: "Order_list_api/order_detailed_list",
  ORDER_TYPE_ORDER_LIST_COUNT: "Order_list_api/order_detailed_count",
  GET_ZIP_CODE_CITY: "https://api.zippopotam.us/US/",

  // Digital Marketing Tags
  DIGITALMAKRTING_LIST: "Store_setting_react_api/digital_marketing_tags_list",
  DIGITALMAKRTING_UPDATE: "Store_setting_react_api/add_digital_marketing_tags",
  DELETE_DIGITALMAKRTING:
    "Store_setting_react_api/delete_digital_marketing_tags",
  GET_BRAND_DATA_LIST: "Product_api_react/list_brand_tag",
  PRODUCT_LOOKUP_LIST: "Product_api_react/lookup_list",
  PRODUCT_LOOKUP_ADD: "Product_api_react/lookup_add",
  PRODUCT_LOOKUP_DELETE: "Product_api_react/lookup_delete",
  ADD_NEW_BRANDS_DATA: "Product_api_react/add_brand_tag",
  UPDATE_BRANDS_DATA: "Product_api_react/update_brand_tag",
  DELETE_BRAND_DATA: "Product_api_react/delete_brand_tag",
  MERGE_BRAND_TAG: "Product_api_react/merge_brand_tag",
  // Brand drag-reorder unified under SORT_CATOGRY_DATA with table='brand_tags'.
  // See docs/new-inventory-schema.md §Endpoints. No separate endpoint needed.

  // Order Retrieve
  SPLIT_LIST: "Order_list_api/get_split_records",
  ORDERRETRIEVE_SUBMIT: "Order_list_api/order_recover",
  STORE_CREDIT_REPORT: "ReportingReactapi/store_credit_report",
  STORE_CREDIT_REPORT_COUNT: "ReportingReactapi/store_credit_count",
  GET_RELATED_PRODUCT: "Product_api_react/getRelatedProduct",
  DETAILED_LOYALTY_POINTS: "ReportingReactapi/loyalty_points_report",
  DETAILED_LOYALTY_POINTS_COUNT: "ReportingReactapi/loyalty_points_data_count",
  IMAGE_DUPLICATE: "Product_api_react/image_duplicate",
  GET_REFUND_EMAILS: "Order_list_api/get_refund_emails",
  GET_REFUND_EMAILS_COUNT: "Order_list_api/get_refund_emails_count",
  CATEGORY_SALES_SUMMERY_REPORT: "ReportingReactapi/category_sale_summary",
  SALES_BY_HOURS_REPORT: "Sale_summary_api/sale_by_hour",
  SALES_BY_HOURS_REPORT_DASHBOARD: "api/reports/sale_by_hour_new",
  TRANSFER_INVENTORY: "Product_api_react/transfer_inventory",
  NEW_CUSTOMER_ADDED_REPORT: "ReportingReactapi/new_customer_added_report",
  REFUND_EMAIL_STATUS_CHANGE: "Order_list_api/refund_email_status_change",
  GET_REGISTER_CLOSURE_LIST:
    "Shift_summary_report_react/shift_summary_report_react",
  GET_SHIFT_SUMMARY_REPORT_ORDER_DETAILS:
    "Shift_summary_report_react/shift_order_details",
  LOYALITY_PROGRAM_STORE_LIST: "LoyaltyProgramReactAPI/loyalty_program",
  SAVE_LOYALITY_PROGRAM: "LoyaltyProgramReactAPI/save_loyalty_program",
  ADD_LOYALITY_PROGRAM: "LoyaltyProgramReactAPI/add_bouns_point_promotions",
  DELETE_LOYALTY_PROGRAM: "LoyaltyProgramReactAPI/delete_loyalty_program",
  GET_LOTTERY_DATA_REPORT: "ReportingReactapi/lottery_payout_report",
  GET_ALL_COUPON_RECORD: "ReportingReactapi/coupon_report",
  GET_PAYMENT_REPORT_DATA: "Sale_summary_api/payment_report",
  // Fact-table (Python/ClickHouse) replacement for the route above.
  // Use with REPORTS_BASE_URL, not BASE_URL. Same `result` shape, but it
  // honours outlet_ids (multi-location) instead of always reporting on the
  // logged-in store, reports a refund-only window instead of going blank, and
  // un-crosses the Lottery / Lottery Non-Scratchers rows that PHP emits under
  // swapped keys.
  PAYMENT_REPORT_FACT_API: "api/reports/payment_report_fact",

  NEW_CUSTOMER_REPORT: "NewSalesReportReactapi/customer_report",
  NEW_CUSTOMER_REPORT_COUNT: "NewSalesReportReactapi/customer_report_count",
  NEW_CUSTOMER_REPORT_SALES_AMOUNT:
    "NewSalesReportReactapi/customer_amount_spent_data",
  EMPLOYEE_SALES_REPORT: "NewEmployeeReport/employee_report",
  RENEVUE_OUTLET_RECORD: "ReportingReactapi/revenue_data_outlet_report",
  // STORE_DISCOUNTED_REPORT: "ReportingReactapi/store_discounted_report",
  STORE_DISCOUNTED_REPORT: "ReportingReactapi/store_discounted_report",
  CUSTOMER_DISCOUNT_REPORT: "ReportingReactapi/customer_count_store_report",
  GROSS_PROFIT_REPORT: "NewDashboardReact/store_gross_profit_api",
  GROSS_PROFIT_REPORT_HOURLY: "NewDashboardReact/gross_profit_api_hourly",
  STORE_SALES_COUNT_REPORT: "NewDashboardReact/store_sales_count_api",

  STORE_AVG_SALES_REPORT: "DashboardReactApi/avg_sale_value_report",
  STORE_AVG_ITEM_SALES_REPORT: "DashboardReactApi/avg_item_sale_report",

  // inventory reporting
  GET_REORDER_INVENTORY_LIST: "InventoryReportPk/Reorder_list",
  REORDER_TOTAL_LIST: "InventoryReportPk/Reorder_total_list",
  CLOSING_INVENTORY_TOTAL: "InventoryReportPk/closing_inventory_total",
  ITEMS_SOLD_TOTAL: "InventoryReportPk/items_sold_total",
  INBOUND_INVENTORY_TOTAL: "InventoryReportPk/inbound_inventory_total",
  NET_SALE_TOTAL: "InventoryReportPk/net_sale_total",
  DYNAMIC_TOTAL_BASE: "InventoryReportPk/",
  STOCKTAKE_HISTORY_REPORT: "InventoryReportPk/stocktake_list",
  CURRENT_INVENTORY_VALUE: "InventoryReportPk/inventory_report",
  NEW_ITEM_CREATED_BETWEEN_LIST:
    "InventoryReportPk/new_item_created_between_list",
  INSTANT_ACTIVITY_REPORT: "InventoryReportPk/instant_po_activity_report",
  LIST_ALL_CATEGORIES: "InventoryReportPk/category_list",
  TOTAL_CURRENT_INVENTORY_VALUE: "InventoryReportPk/inventory_report_Total",
  INVENTORY_LIST: "InventoryReportPk/inventory_list_report",
  QUANTITY_HISTORY_REPORT: "InventoryReportPk/quantity_history_report",
  // INVENTORY_REPORT_EXPORT: "InventoryReportPk/inventory_report_export",
  // add merchent and store
  ADD_MERCHANT_STORE: "UserController/insert_admin_pk",
  GET_MERCHANT_DETAILS: "UserController/get_merchant_admin_pk",

  GET_STORE_DATA: "UserController/edit1",
  GET_PERMISSION_SORTDATA: "api/Create_permission_api/permission_code_sorting",
  // SAVE_CUSTOMER_DETAILS: "Customerapi/save_customer_details",
  SAVE_CUSTOMER_DETAILS: "App/save_customer_details",
  // NEW_CUSTOMER_LIST: "Customer_merchant_api/new_customer_list",
  NEW_CUSTOMER_LIST: "Customerapi/new_customer_list",
  ORDER_BY_CUSTOMER: "Customerapi/order_by_customer",
  ORDER_BY_CUSTOMER_COUNT: "Customerapi/order_by_customer_count",
  LATEST_CUSTOMER_LIST: "Customerapi/latest_customer_list",
  NEW_CUSTOMER_TOTAL_COUNT: "Customerapi/new_customer_list_count",
  // FIND_CUSTOMER: "Customerapi/find_customer",
  FIND_CUSTOMER: "App/find_customer",
  GET_ALL_MERCHANTS_OF_ADMIN: "UserController/get_all_merchant_admin_pk",
  UPDATE_MERCHANTS_OF_ADMIN: "UserController/update_admin_pk",
  // DISABLE_CUSTOMER: "Customerapi/disable_customer",
  DISABLE_CUSTOMER: "Customer_merchant_api/disable_customer",
  // Node /ci only (Online Ordering for Approved Customers Only)
  PENDING_CUSTOMER_LIST: "Customer_merchant_api/pending_customer_list",
  UPDATE_CUSTOMER_APPROVAL_STATUS: "Customer_merchant_api/update_customer_approval_status",
  CASH_MOVEMENT: "Shift_summary_report_react/cash_movement",
  SHIFT_SUMMERY_REPORT_PAYMENT: "Shift_summary_report_react/payments",
  CHECK_UNIQUIE_LOGIN_STORE_NAME: "UserController/check_login_store_name",
  CHECK_UNIQUIE_ADMIN_EMAIL: "UserController/check_admin_employee_email",
  SHIFT_SUMMERY_NEW_SALE: "Shift_summary_report_react/new_sale",

  //add banners
  BANNER_LIST: "OnlineStoreReactNewUI/banners_list",
  BANNER_STATUS: "OnlineStoreReactNewUI/status_change",
  ADD_BANNER: "OnlineStoreReactNewUI/add_banner",
  EDIT_BANNER: "OnlineStoreReactNewUI/edit_banner",
  BANNER_DATA_ID: "OnlineStoreReactNewUI/BannerDataById",
  DELETE_BANNER: "OnlineStoreReactNewUI/deleteBanner",
  DELETE_SELECTED_BANNERS: "OnlineStoreReactNewUI/deleteSelectedBanners",
  GET_BOGO_LIST_ID: "Bogoapi/bogo_list",

  //News Letter
  GET_NEWSLETTER_LIST: "NewsLetter_pk/list",
  DELETE_NEWSLETTER: "NewsLetter_pk/delete",
  UPDATE_NEWSLETTER_STATUS: "NewsLetter_pk/update_status",

  // Bogo Listing
  BOGO_LISTING: "Bogoapi/bogo_list",
  BOGO_STATUS: "Bogoapi/bogo_status",
  BOGO_VARIANT_LISTING: "Product_api_react/variant_list_pagination",
  BOGO_LIST_COUNT: "Product_api_react/variant_list_pagination_count",
  // Variants page — same POS contract the Android register uses to edit one unit.
  GET_PRODUCT_DATA_BY_ID_V2: "Product_api_react/get_productdata_ById_v2",
  GET_VARIANT_DATA_BY_ID: "Productapi/get_variantdata_ById",
  UPDATE_PRODUCT_VARIANT: "Productapi/update_product_variant",
  SORT_VARIANTS: "Product_api_react/sort_variants",
  GENERATE_VARIANT_ALTERNATE_NAMES: "Product_api_react/generate_variant_alternat_names",
  BOGO_ADD: "Bogoapi/add_bogo",
  BOGO_DELETE: "Bogoapi/delete_bogo",

  //for All Inventory Update
  All_Inventory_Update: "ReportingReactapi/all_inventory_qauntity_update",

  CONFIGURE_CATEGORIES_LIST: "Configure_category_api/config_cat_list",
  ADD_CONFIGURE_CATEGORIES: "Configure_category_api/insert_config_cat",
  UPDATE_CONFIGURE_CATEGORY: "Configure_category_api/update_config_cat",
  DELETE_CONFIGURE_CATEGORY: "Configure_category_api/delete_config_cat",

  // Qquickvee Custom
  QUICKVEE_CUSTOM_LIST: "Quickvee_custom_api/quickvee_custom_list",
  QUICKVEE_CUSTOM_INSERT: "Quickvee_custom_api/quickvee_custom_insert",
  QUICKVEE_CUSTOM_UPDATE: "Quickvee_custom_api/quickvee_custom_update",
  QUICKVEE_CUSTOM_DELETE: "Quickvee_custom_api/quickvee_custom_delete",
  QUICKVEE_CUSTOM_EDIT: "Quickvee_custom_api/quickvee_custom_edit",
  QUICKVEE_CUSTOM_CHECKBOX_UPDATE:
    "Quickvee_custom_api/quickvee_custom_checkbox_update",

  QC_LIST: "Quickvee_custom_api/qc_dropdown_list",
  MERGE_CUSTOMER: "Group_management/merge_customers",

  //New SuperAdmin
  SUPERADMIN_LIST: "superadmin/list-superadmins",
  SUPERADMIN_DELETE: "superadmin/delete-superadmin",
  SUPERADMIN_PERMISSION: "superadmin/fetch-superadmins-permissions",
  ADD_SUPERADMIN_PERMISSION: "superadmin/add-superadminPermission",
  SUPERADMIN_ASSIGNED_STORE_LIST: "superadmin/assigned_store_list",
  REFERRAL_BONUS_CONFIG_LIST: "superadmin/list-referral-bonus-configs",
  REFERRAL_BONUS_CONFIG_GET: "superadmin/get-referral-bonus-config",
  REFERRAL_BONUS_CONFIG_CREATE: "superadmin/create-referral-bonus-config",
  REFERRAL_BONUS_CONFIG_UPDATE: "superadmin/update-referral-bonus-config",
  REFERRAL_BONUS_CONFIG_DELETE: "superadmin/delete-referral-bonus-config",
  REFERRAL_BONUS_CONFIG_STATUS_UPDATE:
    "superadmin/update-referral-bonus-config-status",
  // create group API

  // CREATE_GROUP_API: "Group_management/create_group",
  // UPDATE_GROUP_API: "Group_management/update_group",
  CREATE_GROUP_API: "Group_management/create_group_async",
  UPDATE_GROUP_API: "Group_management/update_group_async",
  GROUP_JOB_STATUS_API: "Group_management/job_status",
  FETCH_GROUP_API: "Group_management/get_group_details",

  //Product And Category Discount
  PRODUCT_CATEGORY_DISCOUNT_ADD_UPDATE_DISCOUNT:
    "Product_category_discount/add_update_discount",
  PRODUCT_CATEGORY_DISCOUNT_LIST:
    "Product_category_discount/get_discounts_list",
  TIME_SHEET_LIST_PAY_PERIOD_REVIEW: "Timesheet_api/timesheet_list",
  TIME_SHEET_LIST_DAILY_REVIEW_LIST: "Timesheet_api/daily_review_list",
  GET_ATTENDANCE_BY_ID: "Timesheet_api/get_attendance_by_id",
  ADD_EDIT_TIME_CARD: "Timesheet_api/add_edit_time_card",

  // EXPORT_DATA_MAIL_API: "https://qa-api-node.quickvee.us/exportreport",
  EXPORT_DATA_MAIL_API: "exportreport",
  PAY_PERIOD_SUMMARY: "Timesheet_api/pay_period_summary",
  GET_BREAK_SETTING: "StoreReact_setting_api/get_break_setting",
  UPDATE_BREAK_SETTING: "StoreReact_setting_api/break_setting",
  EMPLOYEE_RATINGS_REPORT: "rating/get_rating_by_id",
  EMPLOYEE_RATINGS_HOME: "rating/get_rating",
  EMPLOYEE_RATING_BY_ID_COUNT: "rating/get_rating_by_id_count",
  GET_ORDER_RATING: "rating/get_rating_by_order_id",

  //Tobacco Scan Data
  GET_FORM_DATA: "tobacco_scan/get_form_data",
  SAVE_UPDATE_FORM_DATA: "tobacco_scan/save_update_form_data",
  TOBACCO_SYNC_DATA: "tobacco_scan/sync_products",
  GET_SYNCED_DATA: "tobacco_scan/get_synced_product",
  GET_SYNCED_DATA_COUNT: "tobacco_scan/get_synced_product_count",
  GET_SCANNED_REPORT: "tobacco_scan/get_scanned_reports",
  GET_SCANNED_REPORT_COUNT: "tobacco_scan/get_scanned_reports_count",
  MANUAL_UPLOAD: "tobacco_scan/manual_upload",
  GET_REPORT: "tobacco_scan/get_report",

  // Dezi Scan Data (Node backend — use with BASE_NODE_URL)
  GET_DEZI_FORM_DATA: "dezi_scan/get_form_data",
  SAVE_UPDATE_DEZI_FORM_DATA: "dezi_scan/save_update_form_data",

  BULK_DELETE_EMPLOYEES: "Store_setting_react_api/bulk_delete_employees",
  BULK_UPDATE_EMPLOYEE_STORES:
    "Store_setting_react_api/bulk_update_employee_stores",
  DELETED_EMPLOYEE_LIST: "Store_setting_react_api/deleted_employee_list",

  // Uber Reports
  UBER_DELIVERY_REPORT: "api/uber_reports/delivery_report",
  UBER_FINANCIAL_SUMMARY: "api/uber_reports/financial_summary",
  UBER_PROOF_OF_DELIVERY: "api/uber_reports/proof_of_delivery",
  // Uber merchant charge-back statement (Node backend — use with BASE_NODE_URL)
  UBER_MERCHANT_STATEMENT: "UberBilling/merchant_statement",

  // Customer feed: merchant posts and the notifications that point at them.
  // Node backend — use with BASE_NODE_URL.
  MERCHANT_FEED_SAVE_POST: "MerchantFeed/save_post",
  MERCHANT_FEED_LIST_POSTS: "MerchantFeed/list_posts",
  MERCHANT_FEED_DELETE_POST: "MerchantFeed/delete_post",
  MERCHANT_FEED_SAVE_NOTIFICATION: "MerchantFeed/save_notification",
  MERCHANT_FEED_SEND_NOTIFICATION: "MerchantFeed/send_notification",
  MERCHANT_FEED_DELETE_NOTIFICATION: "MerchantFeed/delete_notification",
  MERCHANT_FEED_LIST_NOTIFICATIONS: "MerchantFeed/list_notifications",
  MERCHANT_FEED_NOTIFICATION_TARGETS: "MerchantFeed/notification_targets",
  MERCHANT_FEED_NOTIFICATION_AUDIENCE: "MerchantFeed/notification_audience",
  MERCHANT_FEED_FOLLOWER_COUNT: "MerchantFeed/follower_count",
  MERCHANT_FEED_FOLLOWER_LIST: "MerchantFeed/follower_list",

  // Gift cards (Promotions → Gift Card) — same PHP calls as the Android More → Gift Card screen.
  GIFT_CARD_LIST: "Gift_Ebt_api/get_giftcard",
  GIFT_CARD_HISTORY: "Gift_Ebt_api/gift_card_history",
  GIFT_CARD_ADJUST: "Gift_Ebt_api/adjust_giftcard",

  // Product validation: issues the background worker found in a store's
  // catalog. Read-only. Node backend — use with BASE_NODE_URL.
  PRODUCT_VALIDATION_SUMMARY: "ProductValidation/summary",
  PRODUCT_VALIDATION_ISSUES: "ProductValidation/issues",

  // Telnyx Mass SMS
  TELNYX_SMS_GET_CATEGORIES: "telnyx_mass_sms/get_categories",
  TELNYX_SMS_CREATE_CATEGORY: "telnyx_mass_sms/create_category",
  TELNYX_SMS_DELETE_CATEGORY: "telnyx_mass_sms/delete_category",
  TELNYX_SMS_GET_CONTACTS: "telnyx_mass_sms/get_contacts",
  TELNYX_SMS_ADD_CONTACT: "telnyx_mass_sms/add_contact",
  TELNYX_SMS_DELETE_CONTACT: "telnyx_mass_sms/delete_contact",
  TELNYX_SMS_IMPORT_CSV: "telnyx_mass_sms/import_contacts_csv",
  TELNYX_SMS_SEND_MESSAGE: "telnyx_mass_sms/send_message",
  TELNYX_SMS_GET_CONVERSATIONS: "telnyx_mass_sms/get_conversations",
  TELNYX_SMS_GET_MESSAGES: "telnyx_mass_sms/get_messages",
  TELNYX_SMS_REPLY_MESSAGE: "telnyx_mass_sms/reply_message",
  TELNYX_SMS_UPDATE_CONTACT: "telnyx_mass_sms/update_contact",
  TELNYX_SMS_UPDATE_CATEGORY: "telnyx_mass_sms/update_category",
  TELNYX_SMS_MARK_CONVERSATION_READ: "telnyx_mass_sms/mark_conversation_read",
  TELNYX_SMS_GET_UNREAD_COUNT: "telnyx_mass_sms/get_unread_count",
  TELNYX_SMS_GET_CAMPAIGNS: "telnyx_mass_sms/get_campaigns",
  TELNYX_SMS_GET_CAMPAIGN_DETAILS: "telnyx_mass_sms/get_campaign_details",


  // Restricted Keywords (Superadmin)
  RESTRICTED_KEYWORDS_LIST: "Restricted_words_api/get_restricted_words",
  ADD_RESTRICTED_KEYWORD: "Restricted_words_api/add_restricted_words",
  DELETE_SINGLE_RESTRICTED_KEYWORD: "Restricted_words_api/delete_restricted_words",

  EDIT_RESTRICTED_KEYWORD: "Restricted_words_api/add_restricted_words",
  RESTRICTED_KEYWORD_BY_ID: "Restricted_words_api/get_restricted_words",

  /** S3 path segment after BUCKET_BASE_URL for stored banner files */
  FEATURE_ANNOUNCEMENTS_IMAGE_PATH: "upload/feature-announcements/",

  FEATURE_ANNOUNCEMENTS_LIST: "Feature_announcements_api/get_all_feature_announcements",
  ADD_FEATURE_ANNOUNCEMENTS: "Feature_announcements_api/add_feature_announcements",
  DELETE_FEATURE_ANNOUNCEMENTS: "Feature_announcements_api/delete_feature_announcements",
  CHANGE_FEATURE_ANNOUNCEMENTS_STATUS: "Feature_announcements_api/change_announcements_status",
  SHOW_FEATURE_ANNOUNCEMENTS: "Feature_announcements_api/show_feature_announcements",
  ADD_FEATURE_ANNOUNCEMENTS_VIEWED: "Feature_announcements_api/add_feature_announcements_viewed",



  // Quickvee HQ connector (quickveehq.com). Node endpoints — see
  // quickvee-backend-node/router/hq_connector_router.js.
  HQ_CONNECT_STATUS: "HqConnector/admin/status",
  HQ_CONNECT_START: "HqConnector/admin/connect/start",
  HQ_CONNECT_COMPLETE: "HqConnector/admin/connect/complete",
  HQ_CONNECT_DISCONNECT: "HqConnector/admin/disconnect",
  HQ_CONNECT_AUTO_RECEIVE: "HqConnector/admin/store/auto-receive",
  HQ_CONNECT_DOC_RETRY: "HqConnector/admin/documents/retry",
  HQ_CONNECT_DOC_CANDIDATES: "HqConnector/admin/documents/candidates",
  HQ_CONNECT_DOC_RESOLVE: "HqConnector/admin/documents/resolve-line",

  // Lumana video integration. Node endpoints — see
  // quickvee-backend-node/router/lumana_router.js. Owner sessions only.
  LUMANA_STATUS: "Lumana/admin/status",
  LUMANA_CONNECT: "Lumana/admin/connect",
  LUMANA_DISCOVER: "Lumana/admin/discover",
  LUMANA_SETTINGS: "Lumana/admin/settings",
  LUMANA_SNAPSHOT: "Lumana/admin/snapshot",
  LUMANA_TEST: "Lumana/admin/test",
  LUMANA_PAUSE: "Lumana/admin/pause",
  LUMANA_RESUME: "Lumana/admin/resume",
  LUMANA_DISCONNECT: "Lumana/admin/disconnect",
  LUMANA_VIDEO_ORDER: "Lumana/video/order",
  LUMANA_VIDEO_START: "Lumana/video/start",
  LUMANA_VIDEO_STOP: "Lumana/video/stop",
  LUMANA_VIDEO_SNAPSHOT: "Lumana/video/snapshot",

  // mKonnekt / Dezi tobacco-compliance reporting (Node backend — use with BASE_NODE_URL).
  // Re-reports an already-reported sale under a new status so mKonnekt drops it from SkanData
  // generation. See quickvee-backend-node/router/frontend/mkonnekt_discount_router.js.
  MKONNEKT_UPDATE_ORDER_STATUS: "Mkonnekt_discount/update_order_status",
  // Back-office order details: the reporting sweep's per-order sync state, and a manual re-queue.
  MKONNEKT_SYNC_STATUS: "Mkonnekt_discount/sync_status",
  MKONNEKT_SYNC_RETRY: "Mkonnekt_discount/sync_retry",

  // QuickBooks Online — quickvee-backend-node/router/merchant/quickbooks_router.js (V2, daily journal).
  QBO_STATE: "QuickBooks/state",
  QBO_ATTENTION: "QuickBooks/attention",
  QBO_STORE_CONNECT: "QuickBooks/stores/connect",
  QBO_STORE_LINK: "QuickBooks/stores/link",
  QBO_STORE_MODE: "QuickBooks/stores/mode",
  QBO_STORE_UPDATE: "QuickBooks/stores/update",
  QBO_STORE_SETUP: "QuickBooks/stores/setup",
  QBO_STORE_UNLINK: "QuickBooks/stores/unlink",
  QBO_DISCONNECT: "QuickBooks/connections/disconnect",
  QBO_RECONNECT: "QuickBooks/connections/reconnect",
  QBO_NOTIFICATIONS: "QuickBooks/notifications/save",
  QBO_ACCOUNTS: "QuickBooks/accounts/list",
  QBO_ACCOUNT_CREATE: "QuickBooks/accounts/create",
  QBO_MAPPING_GET: "QuickBooks/mapping/get",
  QBO_MAPPING_SAVE: "QuickBooks/mapping/save",
  QBO_PREVIEW: "QuickBooks/preview",
  QBO_POSTING_CREATE: "QuickBooks/postings/create",
  QBO_POSTINGS: "QuickBooks/postings/list",
  QBO_POSTING_DETAIL: "QuickBooks/postings/detail",
  QBO_POSTING_RETRY: "QuickBooks/postings/retry",
  QBO_POSTING_RESOLVE: "QuickBooks/postings/resolve",
  QBO_BACKFILL_REVIEW: "QuickBooks/backfill/review",
  QBO_BACKFILL_START: "QuickBooks/backfill/start",
  QBO_BACKFILL_STATUS: "QuickBooks/backfill/status",
  QBO_AUDIT: "QuickBooks/audit",
  QBO_OAUTH_COMPLETE: "QuickBooks/oauth/complete",

  // Multi-location bulk product update (Node backend — use with BASE_NODE_URL)
  BULK_PRODUCT_UPDATE_SUBMIT: "BulkProductUpdate/submit",
  BULK_PRODUCT_UPDATE_JOBS: "BulkProductUpdate/jobs",
  BULK_PRODUCT_UPDATE_JOB_DETAIL: "BulkProductUpdate/job_detail",
  BULK_PRODUCT_UPDATE_CANCEL: "BulkProductUpdate/cancel",
  BULK_PRODUCT_UPDATE_UPLOAD_IMAGE: "BulkProductUpdate/upload_image",
  BULK_PRODUCT_UPDATE_DELETE_IMAGE: "BulkProductUpdate/delete_image",

  // Store Settings > Bulk Update (Node backend — use with BASE_NODE_URL)
  BULK_STORE_SETTINGS_SCHEMA: "BulkStoreSettings/schema",
  BULK_STORE_SETTINGS_CURRENT_VALUES: "BulkStoreSettings/current_values",
  BULK_STORE_SETTINGS_SUBMIT: "BulkStoreSettings/submit",
  BULK_STORE_SETTINGS_JOBS: "BulkStoreSettings/jobs",
  BULK_STORE_SETTINGS_JOB_DETAIL: "BulkStoreSettings/job_detail",
  BULK_STORE_SETTINGS_CANCEL: "BulkStoreSettings/cancel",
  // Manual item order inside a scope, generic over sort_type (Node backend — use with BASE_NODE_URL).
  // sort_type "category_product" = products inside a category; variants will add their own type.
  CATALOG_SORT_ITEMS: "catalog_sort/items",
  CATALOG_SORT_SORTED: "catalog_sort/sorted",
  CATALOG_SORT_SAVE: "catalog_sort/save",
  STOCKTAKE_TOTAL_PRODUCTS_URL: "total_data/products",
  ITEM_SOLD_REPORT_MERCHANTS: "AZI650720TX,AZI650741TX,AZI650775TX,AZI650798TX,AZI650955TX,AZI652105TX,AZI652109TX,AZI652117TX,AZI652122TX,AZI652168TX,AZI652199TX,AZI652208TX,AZI652238TX,AZI663954TX,AZI663967TX,AZI664014TX,AZI664033TX,AZI664645TX,AZI1817798TX,AZI1827266TX,AZI1827285TX,AZI1827286TX,AZI1827287TX,AZI1827288TX,AZI1827289TX,AZI1827290TX,AZI1827291TX,AZI1827292TX,AZI1827293TX,AZI1827294TX,AZI1827295TX,AZI1827296TX,AZI1827297TX,AZI1827298TX,AZI1827299TX,AZI1827300TX,AZI1827301TX,AZI1827302TX,AZI1827303TX,BIL2215335CA,BIL2222577CA",
  // Owner logins (users.email) whose every store gets the Item/Category Sold reports,
  // including stores added to the account later.
  ITEM_SOLD_REPORT_EMAILS: "rocknrollit1996@gmail.com,bilal@gmail.com",

});
